import React from "react";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
  Tooltip,
  Textarea,
} from "@chakra-ui/react";
import { statesList } from "../../Common/utils";
import { memo, useState, useEffect } from "react";

function RcForm1({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  setFieldError,
  setFieldValue,
  isChecked,
  setIsChecked,
}) {
  const scaleList = ["SMALL", "MEDIUM", "MICRO"];

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    if (event.target.checked) {
      handleChange({
        target: {
          id: "contactName",
          value: values.legalName,
        },
      });
      handleChange({
        target: {
          id: "contactEmail",
          value: values.legalEmail,
        },
      });
      handleChange({
        target: {
          id: "contactNumber",
          value: values.legalContact,
        },
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {}, [values.contactName]);

  return (
    <>
      <Box bg="#fff" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Applicant Details
        </Text>

        <Grid
          templateColumns={{
            base: "1fr",

            md: "1fr",

            lg: "repeat(2, 1fr)",
          }}
          gap={"3rem"}
          marginTop={"1rem"}
        >
          <GridItem colSpan={{ base: "2", md: "2", lg: "1" }}>
            <Box paddingLeft={{ base: "0", md: "2rem" }}>
              <Box>
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent={"center"}
                >
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Name of Organisation{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <Input
                        type="text"
                        id="organizationName"
                        color={"#141D43"}
                        value={values.organizationName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        border="2px solid  #8fd0fd !important"
                        marginTop="10px"
                        bg={"#fff"}
                        fontSize={"14px"}
                        _focusVisible={
                          errors.organizationName && touched.organizationName
                            ? {
                                border: "1px solid red !important",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                      />

                      {errors.organizationName && touched.organizationName && (
                        <Box color="red.500">{errors.organizationName}</Box>
                      )}
                    </GridItem>
                  </Grid>

                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Company Scale{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <Select
                        marginTop={"10px"}
                        bgColor="white"
                        id="organizationCompanyScale"
                        color={" #141D43"}
                        border="2px solid  #8fd0fd !important"
                        fontSize="sm"
                        value={values.organizationCompanyScale}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        _focusVisible={
                          errors.organizationCompanyScale &&
                          touched.organizationCompanyScale
                            ? {
                                border: "1px solid red !important",
                              }
                            : { border: "1px solid #464C64" }
                        }
                      >
                        <option hidden="true">Select Company Scale</option>

                        {scaleList.map((scale, index) => (
                          <option key={index}>{scale}</option>
                        ))}
                      </Select>

                      {errors.organizationCompanyScale &&
                        touched.organizationCompanyScale && (
                          <Box color="red.500" marginTop={"2px"}>
                            {errors.organizationCompanyScale}
                          </Box>
                        )}
                    </GridItem>
                  </Grid>

                  <GridItem width={"100%"}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Address &nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>

                    <Input
                      type="text"
                      color={"#141D43"}
                      id="organizationRawAddress"
                      marginTop="10px"
                      border="2px solid  #8fd0fd !important"
                      w="100%"
                      bg={"#fff"}
                      value={values.organizationRawAddress}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fontSize={"14px"}
                      _active={
                        errors.organizationRawAddress &&
                        touched.organizationRawAddress
                          ? {
                              border: "1px solid red",
                            }
                          : { border: "1px solid #464C64" }
                      }
                      _placeholder={{
                        opacity: 1,

                        color: " #464C64",

                        fontSize: "14px",
                      }}
                    />

                    {errors.organizationRawAddress &&
                      touched.organizationRawAddress && (
                        <Box color="red.500">
                          {errors.organizationRawAddress}
                        </Box>
                      )}
                  </GridItem>

                  <Grid
                    width={"100%"}
                    templateColumns={{
                      base: "1fr",

                      md: "repeat(2, 1fr)",
                    }}
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        City
                      </Text>

                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        id="organizationCity"
                        bg={"#fff"}
                        border="2px solid  #8fd0fd !important"
                        value={values.organizationCity}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                      />

                      {errors.organizationCity && touched.organizationCity && (
                        <Box color="red.500">{errors.organizationCity}</Box>
                      )}
                    </GridItem>

                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        State &nbsp;
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <Select
                        marginTop={"10px"}
                        bgColor="white"
                        id="organizationState"
                        color={" #141D43"}
                        border="2px solid  #8fd0fd !important"
                        fontSize="sm"
                        value={values.organizationState}
                        onChange={handleChange}
                        _active={
                          errors.organizationState && touched.organizationState
                            ? {
                                border: "1px solid red",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        onBlur={handleBlur}
                      >
                        <option hidden="true">Select State</option>

                        {statesList.map((state, index) => (
                          <option default="true" key={index}>
                            {state}
                          </option>
                        ))}
                      </Select>

                      {errors.organizationState &&
                        touched.organizationState && (
                          <Box color="red.500">{errors.organizationState}</Box>
                        )}
                    </GridItem>
                  </Grid>

                  <Grid
                    width={"100%"}
                    templateColumns={{
                      base: "1fr",

                      md: "repeat(2, 1fr)",
                    }}
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Pincode
                      </Text>

                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        id="organizationPinCode"
                        bg={"#fff"}
                        border="2px solid  #8fd0fd !important"
                        value={values.organizationPinCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                      />

                      {errors.organizationPinCode &&
                        touched.organizationPinCode && (
                          <Box color="red.500">
                            {errors.organizationPinCode}
                          </Box>
                        )}
                    </GridItem>

                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Country
                      </Text>

                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        id="organizationCountry"
                        bg={"#fff"}
                        value={values.organizationCountry}
                        onChange={handleChange}
                        border="2px solid  #8fd0fd !important"
                        onBlur={handleBlur}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                      />

                      {errors.organizationCountry &&
                        touched.organizationCountry && (
                          <Box color="red.500">
                            {errors.organizationCountry}
                          </Box>
                        )}
                    </GridItem>
                  </Grid>
                </Box>
              </Box>
            </Box>

            <Tooltip label="Please provide these details correctly, this is the email on which all the communication is done.">
              <Text
                color={"#141D43"}
                fontSize="lg"
                fontWeight={"800"}
                marginBottom="5px"
              >
                Legal Representative
              </Text>
            </Tooltip>

            <Box
              border={"2px solid #2272D5"}
              width="15%"
              marginBottom={"1rem"}
            ></Box>

            <Box paddingLeft={{ base: "0", md: "3rem" }}>
              <Box>
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent={"center"}
                >
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Name {""}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        id="legalName"
                        bg={"#fff"}
                        value={values.legalName}
                        onChange={handleChange}
                        border="2px solid  #8fd0fd !important"
                        onBlur={handleBlur}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                        _focusVisible={
                          errors.legalName && touched.legalName
                            ? {
                                border: "1px solid red !important",
                              }
                            : { border: "1px solid #464C64" }
                        }
                      />

                      {errors.legalName && touched.legalName && (
                        <Box color="red.500">{errors.legalName}</Box>
                      )}
                    </GridItem>

                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Contact {""}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <Input
                        type="number"
                        color={"#141D43"}
                        marginTop="10px"
                        id="legalContact"
                        bg={"#fff"}
                        value={values.legalContact}
                        onChange={handleChange}
                        border="2px solid  #8fd0fd !important"
                        onBlur={handleBlur}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                        _focusVisible={
                          errors.legalContact && touched.legalContact
                            ? {
                                border: "1px solid red !important",
                              }
                            : { border: "1px solid #464C64" }
                        }
                      />

                      {errors.legalContact && touched.legalContact && (
                        <Box color="red.500">{errors.legalContact}</Box>
                      )}
                    </GridItem>
                  </Grid>

                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    gap="3rem"
                    my={"1rem"}
                  >
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Email {""}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <Tooltip label="Please provide the email correctly, this is the email on which all the communication is done.">
                        <Input
                          type="text"
                          id="legalEmail"
                          color={"#141D43"}
                          value={values.legalEmail}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          border="2px solid  #8fd0fd !important"
                          marginTop="10px"
                          bg={"#fff"}
                          fontSize={"14px"}
                          _focusVisible={
                            errors.legalEmail && touched.legalEmail
                              ? {
                                  border: "2px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          _placeholder={{
                            opacity: 1,

                            color: " #464C64",

                            fontSize: "14px",
                          }}
                        />
                      </Tooltip>

                      {errors.legalEmail && touched.legalEmail && (
                        <Box color="red.500">{errors.legalEmail}</Box>
                      )}
                    </GridItem>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </GridItem>

          <GridItem>
            <Box marginTop={{ base: "2rem", md: "-2rem" }}>
              <Text
                color={"#141D43"}
                fontSize="lg"
                fontWeight={"800"}
                marginBottom="5px"
              >
                Point of Contact
              </Text>

              <Box
                border={"2px solid #2272D5"}
                width="15%"
                marginBottom={"1rem"}
              ></Box>

              {values?.legalName &&
                values?.legalEmail &&
                values?.legalContact && (
                  <Checkbox
                    paddingLeft={{ base: "0", md: "3rem" }}
                    mt="1rem"
                    variant="checkbox"
                    isChecked={isChecked}
                    onChange={handleCheckboxChange}
                  >
                    Same as legal representative
                  </Checkbox>
                )}

              <Box>
                <Box
                  paddingLeft={{ base: "0", md: "3rem" }}
                  display={"flex"}
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent={"center"}
                >
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Name {""}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <Input
                        type="text"
                        id="contactName"
                        color={"#141D43"}
                        value={
                          isChecked ? values.legalName : values.contactName
                        }
                        onChange={(e) => {
                          const newValue = isChecked
                            ? values.legalName
                            : e.target.value;

                          handleChange({
                            target: {
                              id: "contactName",

                              value: newValue,
                            },
                          });
                        }}
                        onBlur={isChecked ? "" : handleBlur}
                        disabled={isChecked ? true : ""}
                        border="2px solid  #8fd0fd !important"
                        marginTop="10px"
                        bg={"#fff"}
                        fontSize={"14px"}
                        opacity={"1 !important"}
                        _focusVisible={
                          isChecked
                            ? { border: "1px solid #464C64" }
                            : errors.contactName && touched.contactName
                            ? {
                                border: "2px solid red !important",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                      />

                      {isChecked
                        ? ""
                        : errors.contactName &&
                          touched.contactName && (
                            <Box color="red.500">{errors.contactName}</Box>
                          )}
                    </GridItem>
                  </Grid>

                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Email {""}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <Input
                        w={{ base: "100%", md: "100%", lg: "100%" }}
                        type="text"
                        id="contactEmail"
                        color={"#141D43"}
                        value={
                          isChecked ? values.legalEmail : values.contactEmail
                        }
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={isChecked ? "" : handleBlur}
                        disabled={isChecked ? true : ""}
                        border="2px solid  #8fd0fd !important"
                        marginTop="10px"
                        opacity={"1 !important"}
                        bg={"#fff"}
                        fontSize={"14px"}
                        _focusVisible={
                          isChecked
                            ? { border: "1px solid #464C64" }
                            : errors.contactEmail && touched.contactEmail
                            ? {
                                border: "2px solid red !important",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        _active={
                          errors.contactEmail && touched.contactEmail
                            ? {
                                border: "1px solid red",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                      />

                      {isChecked
                        ? ""
                        : errors.contactEmail &&
                          touched.contactEmail && (
                            <Box color="red.500">{errors.contactEmail}</Box>
                          )}
                    </GridItem>

                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Contact Number {""}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <Input
                        type="text"
                        id="contactNumber"
                        w={{ base: "100%", md: "100%", lg: "100%" }}
                        color={"#141D43"}
                        value={
                          isChecked ? values.legalContact : values.contactNumber
                        }
                        onChange={(e) => {
                          const newValue = isChecked
                            ? values.legalContact
                            : e.target.value;

                          handleChange({
                            target: {
                              id: "contactNumber",

                              value: newValue,
                            },
                          });
                        }}
                        disabled={isChecked ? true : ""}
                        onBlur={isChecked ? "" : handleBlur}
                        border="2px solid  #8fd0fd !important"
                        opacity={"1 !important"}
                        marginTop="10px"
                        bg={"#fff"}
                        fontSize={"14px"}
                        _focusVisible={
                          isChecked
                            ? { border: "1px solid #464C64" }
                            : errors.contactNumber && touched.contactNumber
                            ? {
                                border: "2px solid red !important",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                      />

                      {isChecked
                        ? ""
                        : errors.contactNumber &&
                          touched.contactNumber && (
                            <Box color="red.500">{errors.contactNumber}</Box>
                          )}
                    </GridItem>
                  </Grid>

                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Website/URL
                      </Text>

                      <Input
                        type="text"
                        id="organizationWebsite"
                        color={"#141D43"}
                        value={values.organizationWebsite}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        border="2px solid  #8fd0fd !important"
                        marginTop="10px"
                        bg={"#fff"}
                        fontSize={"14px"}
                        _focusVisible={
                          errors.organizationWebsite &&
                          touched.organizationWebsite
                            ? {
                                border: "2px solid red !important",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                      />

                      {errors.organizationWebsite &&
                        touched.organizationWebsite && (
                          <Box color="red.500">
                            {errors.organizationWebsite}
                          </Box>
                        )}
                    </GridItem>
                  </Grid>

                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Brief Description about Organisation
                      </Text>

                      <Textarea
                        type="text"
                        id="contactDescription"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        value={values.contactDescription}
                        onChange={handleChange}
                        border="2px solid  #8fd0fd !important"
                        onBlur={handleBlur}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,

                          color: " #464C64",

                          fontSize: "14px",
                        }}
                        _active={
                          errors.contactDescription &&
                          touched.contactDescription
                            ? {
                                border: "1px solid red",
                              }
                            : { border: "1px solid #464C64" }
                        }
                      />

                      {errors.contactDescription &&
                        touched.contactDescription && (
                          <Box color="red.500">{errors.contactDescription}</Box>
                        )}
                    </GridItem>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
}

export default memo(RcForm1);
